// Le etichette dei ruoli vivono in lang.js (nodi Ruoli, RuoliTitolo,
// RuoliDescrizioni) indicizzate col nome Spatie del ruolo. I nomi contengono
// spazi e trattini, quindi la chiave va in notazione a parentesi: con il punto
// vue-i18n spezzerebbe il percorso sullo spazio.
function roleKey(node, name) {
  return node + '["' + name + '"]';
}

function hasRoleKey(vm, key) {
  return vm.$te(key) || vm.$te(key, "it");
}

// Ruolo senza etichetta: si mostra il nome grezzo, mai la chiave di traduzione
export function roleLabel(vm, name, node = "Ruoli") {
  const key = roleKey(node, name);
  return hasRoleKey(vm, key) ? vm.$t(key) : name;
}

export function roleDescription(vm, name) {
  const key = roleKey("RuoliDescrizioni", name);
  return hasRoleKey(vm, key) ? vm.$t(key) : "";
}

// Etichetta da titolo (RuoliTitolo), per i testi dove il ruolo sta accanto a
// nomi propri. I ruoli che RuoliTitolo non ha ripiegano su Ruoli e poi sul
// nome, con l'iniziale maiuscola.
export function roleTitle(vm, name) {
  const key = roleKey("RuoliTitolo", name);
  if (hasRoleKey(vm, key)) return vm.$t(key);
  const label = roleLabel(vm, name);
  return label ? label.charAt(0).toUpperCase() + label.slice(1) : label;
}
